import { Controller } from "@hotwired/stimulus"

// Mobile-only drawer for the contacts page (<lg widths). The desktop filters
// rail is hidden on mobile, so this slides in a panel holding the same group
// links + filter selects. It mirrors mobile_nav_controller's open/close/.active
// pattern and reuses the .mobile-nav-overlay / .mobile-nav-drawer CSS so it
// looks identical to the top-nav drawer. A SEPARATE controller instance (not
// the top-nav one) keeps the two drawers independent.
export default class extends Controller {
  static targets = ["drawer", "overlay"]

  connect() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.addEventListener("click", () => this.close())
    }
    this._onResize = () => { if (window.innerWidth > 992) this.close() }
    window.addEventListener("resize", this._onResize)
  }

  disconnect() {
    if (this._onResize) window.removeEventListener("resize", this._onResize)
  }

  open() {
    if (this.hasDrawerTarget) this.drawerTarget.classList.add("active")
    if (this.hasOverlayTarget) this.overlayTarget.classList.add("active")
    document.body.classList.add("nav-open")
  }

  close() {
    if (this.hasDrawerTarget) this.drawerTarget.classList.remove("active")
    if (this.hasOverlayTarget) this.overlayTarget.classList.remove("active")
    document.body.classList.remove("nav-open")
  }

  toggle() {
    if (this.hasDrawerTarget && this.drawerTarget.classList.contains("active")) {
      this.close()
    } else {
      this.open()
    }
  }
}
